import { render, staticRenderFns } from "./RegisterAdmin.vue?vue&type=template&id=5adbb408&"
import script from "./RegisterAdmin.vue?vue&type=script&lang=js&"
export * from "./RegisterAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports